import { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import * as animationData from './images/loading.json';

const defaultOptions = {
  loop: true,  // Keep loop as true to continuously play the animation
  autoplay: true, 
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const Loading = () => {

  return (
    <div className="flex justify-center items-center">
      <Lottie 
        options={defaultOptions}
        height={70}
        width={70}
      />
    </div>
  );
};

export default Loading;
